import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, user } = useAuthStore();

  console.log('ProtectedRoute - user:', user, 'allowedRoles:', allowedRoles);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.rol)) {
    // Si el usuario no tiene permiso, redirigir a su dashboard o página principal
    switch (user?.rol) {
      case 'ADMIN':
      case 'SISTEMAS':
        return <Navigate to="/admin/dashboard" replace />;
      case 'SUPERVISOR':
        return <Navigate to="/supervisor/dashboard" replace />;
      case 'JEFE_SELECCION':
        return <Navigate to="/jefe-seleccion/dashboard" replace />;
      case 'ANALISTA':
        return <Navigate to="/analista/procesos" replace />;
      case 'RECLUTADOR':
        return <Navigate to="/reclutador/procesos" replace />;
      case 'POSTULANTE':
        return <Navigate to="/postulante/dashboard" replace />;
      default:
        return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
